<script lang="ts">
    import { Comment, Text, cloneVNode, defineComponent, watch } from 'vue';
    import { useScrollableStore } from '@/stores/scrollableStore';

    export default defineComponent({
        name: 'BasePopup',
        inheritAttrs: false,
        props: {
            isOpen: {
                type: Boolean,
                default: true,
            },
        },
        setup(props, { slots, attrs }) {
            const { setIsScrollable } = useScrollableStore();

            watch(() => props.isOpen, (isOpen, _wasOpen, onCleanup) => {
                if (!isOpen) return;

                setIsScrollable(false);
                onCleanup(() => setIsScrollable(true));
            }, { immediate: true });

            return () => {
                if (!props.isOpen) return null;

                const children = slots.default?.() ?? [];
                const roots = children.filter(child => child.type !== Comment && child.type !== Text);

                return roots.length === 1 ? cloneVNode(roots[0], attrs) : children;
            };
        },
    });
</script>
